const STRICT_NUMBER_REGEX = /^[-+]?((\d+([.,]\d+)?)|([.,]\d+))$/

export const parseExamValue = (rawValue: string): string | number => {
  const value = rawValue.trim()
  if (!value) {
    return ''
  }

  if (!STRICT_NUMBER_REGEX.test(value)) {
    return value
  }

  const numericValue = Number(value.replace(',', '.'))
  return Number.isNaN(numericValue) ? value : numericValue
}

export const toNumericValue = (value: unknown): number | null => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null
  }

  if (typeof value !== 'string') {
    return null
  }

  const normalized = value.trim().replace(',', '.')
  if (!STRICT_NUMBER_REGEX.test(normalized)) {
    return null
  }

  const parsed = Number(normalized)
  return Number.isFinite(parsed) ? parsed : null
}

